import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import bw from "../assets/BW.png";
import trustbuilder from "../assets/trustbuilder.png";
import bwAndroid from "../assets/bwAndroid.png";
import bwIOS from "../assets/bwIOS.png";
import dw from "../assets/delaware.jpg";
import books from "../assets/books.png";
import games from "../assets/gamecenter.png";
import zatre from "../assets/zatre.jpg";
import meOld from "../assets/meOld.png";
import meNew from "../assets/meNew.png";
import febries from "../assets/febris.png";
import visionWeb from "../assets/visionWeb.png";
import visionMob from "../assets/visionMob.png";
import vhbuildup from "../assets/vhbuildup.png";
import cv from "../assets/downloads/Curriculum_vitae_Lander_De_Kesel.pdf";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { useTranslation } from "react-i18next";

export const Portfolio = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Lander De Kesel - Portfolio";
    window.scrollTo(0, 0);
    AOS.init();
  }, []);

  return (
    <>
      <section className="portfolioContainer">
        <div className="portfolioIntro">
          <h1>
            <span style={{ color: "#0077ff" }}>{t("portfolio.my")}</span>{" "}
            Portfolio.
          </h1>
          <p>{t("portfolio.title")}</p>
        </div>
        <div
          data-aos-delay="1000"
          data-aos-duration="2000"
          data-aos="fade-up"
          className="projectContainer"
        >
          <div>
            <div className="curvit">
              <h1>{t("portfolio.curvit")}</h1>
              <Link className="authButtons" to={cv} target="_blank">
                Curriculum Vitae
              </Link>
            </div>
          </div>
          <br />
          <br />
          <VerticalTimeline layout="1-column-left" lineColor="#0077ff">
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="2023 - present"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
              position="right"
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={bw} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>BlitzWare</h1>
                  <p>{t("portfolio.blitzware.text")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>JavaScript</small>
                    <small>React JS</small>
                    <small>Node JS</small>
                    <small>MySQL</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://blitzware.xyz/"
                    target="_blank"
                  >
                    {t("shared.visit_website")}
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="August 2024"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
              position="right"
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={vhbuildup} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>VH BuildUp!</h1>
                  <p>{t("portfolio.vhbuildup.text_1")}</p>
                  <p>{t("portfolio.vhbuildup.text_2")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>JavaScript</small>
                    <small>React JS</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://www.vhbuildup.be/"
                    target="_blank"
                  >
                    {t("shared.visit_website")}
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="February 2024 - May 2024"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
              position="right"
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={trustbuilder} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>TrustBuilder</h1>
                  <p>{t("portfolio.trustbuilder.text")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>Sass (SCSS)</small>
                    <small>TypeScript</small>
                    <small>Angular</small>
                    <small>Jest</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://www.trustbuilder.com/"
                    target="_blank"
                  >
                    TrustBuilder
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="November 2023 - January 2024"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
              position="right"
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={bwAndroid} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>BlitzWare Android Mobile</h1>
                  <p>{t("portfolio.blitzware_android_mobile.text")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>Kotlin</small>
                    <small>Android Studio</small>
                    <small>SQLite</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://github.com/LanderDK/blitzware-android"
                    target="_blank"
                  >
                    Repository
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="November 2023 - January 2024"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
              position="right"
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={bwIOS} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>BlitzWare IOS Mobile</h1>
                  <p>{t("portfolio.blitzware_ios_mobile.text")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>Swift</small>
                    <small>SwiftUI</small>
                    <small>Xcode</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://github.com/LanderDK/blitzware-ios"
                    target="_blank"
                  >
                    Repository
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="September - December 2023"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
              position="right"
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={visionMob} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>Vision Eye Center Mobile</h1>
                  <p>{t("portfolio.vision_mobile.text_1")}</p>
                  <p>{t("portfolio.vision_mobile.text_2")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>Kotlin</small>
                    <small>Android Studio</small>
                    <small>SQLite</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://github.com/LanderDK/devops-23-24-android-g07"
                    target="_blank"
                  >
                    Repository
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="September - December 2023"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
              position="right"
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={visionWeb} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>Vision Eye Center Web</h1>
                  <p>{t("portfolio.vision_web.text_1")}</p>
                  <p>{t("portfolio.vision_web.text_2")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>.NET</small>
                    <small>Blazor Server</small>
                    <small>MSSQL</small>
                  </div>
                  <br />
                  <div className="btn-container">
                    <Link
                      className="authButtons"
                      to="https://vichogent.be:40157/"
                      target="_blank"
                    >
                      {t("shared.visit_website")}
                    </Link>
                    <Link
                      className="authButtons"
                      to="https://github.com/LanderDK/devops-23-24-net-g07"
                      target="_blank"
                    >
                      Repository
                    </Link>
                  </div>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="September - October 2023"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={febries} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>Febris Biorisk Consult</h1>
                  <p>{t("portfolio.febris.text")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>JavaScript</small>
                    <small>React JS</small>
                    <small>Node JS</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://febrisbiorisk.com/"
                    target="_blank"
                  >
                    {t("shared.visit_website")}
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="May 2023"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={meNew} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>Lander's Website 2.0</h1>
                  <p>{t("portfolio.me_new.text")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>JavaScript</small>
                    <small>React JS</small>
                  </div>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="January - June 2023"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={dw} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>Delaware B2B Portal</h1>
                  <p>{t("portfolio.delaware.text_1")}</p>
                  <p>{t("portfolio.delaware.text_2")}</p>
                  <p>{t("portfolio.delaware.text_3")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>JavaScript</small>
                    <small>React JS</small>
                    <small>Node JS</small>
                    <small>Java</small>
                    <small>JavaFX</small>
                    <small>JPA</small>
                    <small>MySQL</small>
                  </div>
                  <br />
                  <div className="btn-container">
                    <Link
                      className="authButtons"
                      to="https://sdp2-g05.onrender.com/"
                      target="_blank"
                    >
                      {t("shared.visit_website")}
                    </Link>
                    <Link
                      className="authButtons"
                      to="https://github.com/LanderDK/2023-java-delaware"
                      target="_blank"
                    >
                      Desktop App Repository
                    </Link>
                  </div>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="April - May 2023"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={books} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>Lander's Library</h1>
                  <p>{t("portfolio.library.text_1")}</p>
                  <p>{t("portfolio.library.text_2")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>Java</small>
                    <small>JPA</small>
                    <small>Spring Boot</small>
                    <small>CSS</small>
                    <small>MySQL</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://github.com/LanderDK/Bibliotheek_ExamenOpdracht"
                    target="_blank"
                  >
                    Repository
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="September - December 2022"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={games} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>GameCenter</h1>
                  <p>{t("portfolio.gamecenter.text_1")}</p>
                  <p>{t("portfolio.gamecenter.text_2")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>JavaScript</small>
                    <small>React JS</small>
                    <small>Node JS</small>
                    <small>MySQL</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://gamecenter-app.onrender.com/"
                    target="_blank"
                  >
                    {t("shared.visit_website")}
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="January - June 2022"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={zatre} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>Zatre</h1>
                  <p>{t("portfolio.zatre.text")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>Java</small>
                    <small>JavaFX</small>
                    <small>CSS</small>
                    <small>MySQL</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://github.com/LanderDK/2022-java-zatre"
                    target="_blank"
                  >
                    Repository
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                borderRadius: "15px",
                boxShadow: "0 8px 30px #4eafff88",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 255, 255)",
              }}
              date="December 2021"
              iconStyle={{ background: "#0077ff", color: "#fff" }}
            >
              <div className="projectItemContainer">
                <div className="projectItemLeft">
                  <img className="bw" src={meOld} alt="" />
                </div>
                <div className="projectItemRight">
                  <h1>Lander's Website 1.0</h1>
                  <p>{t("portfolio.me_old.text")}</p>
                  <br />
                  <small>{t("portfolio.tech_used")}</small>
                  <div className="technologiesContainer">
                    <small>HTML</small>
                    <small>CSS</small>
                    <small>JavaScript</small>
                  </div>
                  <br />
                  <Link
                    className="authButtons"
                    to="https://landerdekesel-old.netlify.app/"
                    target="_blank"
                  >
                    {t("shared.visit_website")}
                  </Link>
                </div>
              </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
            />
          </VerticalTimeline>
        </div>
      </section>
    </>
  );
};
